import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {schoolwork12} from "@tva/ng-migration/common/util";

export class HttpBaseService {
    headers = {
        "Content-Type": "application/json"
    };

    constructor(protected client: HttpClient) {
    }


    public get(path: string, headers?: any): Observable<any> {
        return this.client.get(this.prepareURL(path),  { headers: headers || this.headers});
    }

    public post(path: string, data: any, headers?: any): Observable<any> {
        return this.client.post(this.prepareURL(path), data, { headers: headers || this.headers});
    }

    public delete(path: string, headers?: any): Observable<any> {
        return this.client.delete(this.prepareURL(path), { headers: headers || this.headers});
    }

    public put(path: string, data: any, headers?: any): Observable<any> {
        return this.client.put(this.prepareURL(path), data, { headers: headers || this.headers});
    }

    private prepareURL(path: string): string {
        return schoolwork12.app.endpoint.concat(path);
    }
}
